import React, { useMemo, useState, memo, useCallback } from 'react'
import classNames from 'classnames'
import { useAppData, useRouteProps } from 'umi'
import createRoutes from '@/routes/createRoutes'
import toolsRoutes from '@/routes/toolsRoutes'
import { ReactComponent as ToolCutoutIcon } from '@/assets/icon/logo/tool-cutout.svg'
import { ReactComponent as ToolExpandIcon } from '@/assets/icon/logo/tool-expand.svg'
import { ReactComponent as ToolQualityIcon } from '@/assets/icon/logo/tool-quality.svg'
import { ReactComponent as ToolBackgroundReplacement } from '@/assets/icon/logo/tool-change-bg.svg'
import { ReactComponent as ToolTranslate } from '@/assets/icon/logo/tool-translate.svg'


import Menu from '../Menu'

import styles from './index.less'

const [{ routes: routes_create }] = createRoutes
const [{ routes: routes_tool }] = toolsRoutes

const ToolsPageMeta = new Map([
  [
    '/tools/image-cutout',
    {
      crumbIcon: <ToolCutoutIcon />,
    },
  ],
  [
    '/tools/image-expand',
    {
      crumbIcon: <ToolExpandIcon />,
    },
  ],
  [
    '/tools/image-quality',
    {
      crumbIcon: <ToolQualityIcon />,
    },
  ],
  [
    '/tools/background-replacement',
    {
      crumbIcon: <ToolBackgroundReplacement />,
    },
  ],
  [
    '/tools/image-translate',
    {
      crumbIcon: <ToolTranslate />,
    },
  ],
])

const menus: any[] = ([] as any[])
  .concat(
    (routes_create as any[]).map((router: any) => ({
      ...router,
      checkLogin: true,
    })),
  )
  .concat(routes_tool as any)
  .map((router: any) => ({
    path: router.path,
    logo: router?.meta?.menuIcon,
    name: router?.name,
    // 跳转校验
    check: router?.meta?.check,
    notNeedLogin: router?.meta?.notNeedLogin||false,
  }))

const CrumbNav = () => {
  const router = useRouteProps()
  const [showLine, setShowLine] = useState(true)
  // const appData = useAppData()

  // console.log("====router", router)
  // console.log("====appData", appData)

  const crumbIcon = useMemo(() => {
    return ToolsPageMeta.get(router?.path)?.crumbIcon
  }, [router?.path])

  const handleToggleLine = useCallback((v: boolean) => {
    setShowLine(v)
  }, [])

  return (
    <>
      <div className={styles.line} style={{ opacity: showLine ? 1 : 0 }} />
      <div className={styles.navWrapper} onMouseOver={handleToggleLine.bind(null, false)} onMouseLeave={handleToggleLine.bind(null, true)}>
        <div className={styles.crumb}>
          {crumbIcon}
          <span className={classNames([`icon-TriDown`, styles.icon])} />
        </div>
        <div className={styles.placeWrapper}>
          <div className={styles.navPopup}>
            <Menu menus={menus} />
          </div>
        </div>
      </div>
    </>
  )
}

export default memo(CrumbNav)
